
const firebaseConfig = {
  apiKey: "AIzaSyBqJHuKD2RA0muYNWUkXt_2h2JxHS-IRvY",
  authDomain: "bike-software-42891.firebaseapp.com",
  projectId: "bike-software-42891",
  storageBucket: "bike-software-42891.appspot.com",
  messagingSenderId: "965921569911",
  appId: "1:965921569911:web:5a21d1626f898a35b91a72"
};
  export default firebaseConfig;
  